import * as api from '../api/api';
import { ERROR_RETRY } from '../Error';

export const doChangeUserAllowMarketing = ({
  contract = CONTRACT_INITIAL,
  allowMarketing = false,
  afterChangeContract = () => {},
}) => {
  api
    .putCurrentUserContract({
      ...contract,
      allowMarketing,
    })
    .then((response) => {
      afterChangeContract(response.data);
      if (allowMarketing){
        api.postVoucherCoupon({ code: '22_11_MARK_AGR' }).catch(() => {});
      } 
      else {
        api.getVoucherCouponList({ status: 'usable' }).then((response) => {
          const marketingAgreeCoupon = response.data.find(e => e.code === '22_11_MARK_AGR');
          if (marketingAgreeCoupon) {
            api.putVoucherCouponStatus({
              id: marketingAgreeCoupon.id, 
              status: 'EXPIRED'
            });
          }
        });
      }
    })
    .catch(() => alert(ERROR_RETRY));
};

export const CONTRACT_INITIAL = {
  agreeTermsOfUse: true,
  allowMarketing: false,
  allowNotification: true,
  allowPersonalInfo: true,
};
